"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _icons = require("@material-ui/icons");
var _styles = _interopRequireDefault(require("./styles"));
var _themes = require("../../themes");
var _contexts = require("../../contexts");
var _StylesPopover = _interopRequireDefault(require("../PopoverWrapper/StylesPopover"));
var _ReferencesPopover = _interopRequireDefault(require("../PopoverWrapper/ReferencesPopover"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } /* eslint-disable react/jsx-no-bind */ // Styles
// Contexts
// Components
function TopBarMobile() {
  var classes = (0, _styles.default)();
  var {
    toggleStylePopover,
    toggleReferencesPopover
  } = (0, _react.useContext)(_contexts.SideBarContext);
  var {
    setCopyValue,
    getPercentageCharsCopied
  } = (0, _react.useContext)(_contexts.CopyrightContext);
  var {
    currentLocation,
    totalLocation,
    currentPercentage,
    loadingLocations,
    currentEndLocation
  } = (0, _react.useContext)(_contexts.EpubReaderContext);
  var {
    backgroundStyle
  } = (0, _react.useContext)(_contexts.ReaderPreferencesContext);
  var [anchorEl, setAnchorEl] = _react.default.useState(null);
  var open = Boolean(anchorEl);
  var handleClick = event => {
    setAnchorEl(event.currentTarget);
  };
  var handleClose = () => {
    setAnchorEl(null);
  };
  var bgColor = _themes.EPUB_READER_THEMES[backgroundStyle].body.backgroundColor;
  var buttonClass = backgroundStyle === 'dark' ? classes.topBarButtonDM : classes.topBarButton;
  var openStylePopover = () => {
    toggleStylePopover(true);
    setAnchorEl(null);
  };
  var openReferencesPopover = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(function* () {
      setCopyValue(yield getPercentageCharsCopied());
      toggleReferencesPopover(true);
      setAnchorEl(null);
    });
    return function openReferencesPopover() {
      return _ref.apply(this, arguments);
    };
  }();
  var renderLocationLabel = () => {
    if (loadingLocations) {
      return /*#__PURE__*/_react.default.createElement("span", null, "Carregando...");
    }
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, currentLocation === currentEndLocation ? currentLocation : "".concat(currentLocation, "-").concat(currentEndLocation), ' / ', totalLocation, ' ', "(", currentPercentage, "%)");
  };
  return /*#__PURE__*/_react.default.createElement(_core.AppBar, {
    position: "fixed",
    className: classes.topBarWrapper,
    style: {
      backgroundColor: bgColor
    }
  }, /*#__PURE__*/_react.default.createElement(_core.Toolbar, {
    className: classes.topBartoolbar
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    onClick: () => window.history.back(),
    classes: {
      root: buttonClass
    }
  }, /*#__PURE__*/_react.default.createElement(_icons.NavigateBefore, null)), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.locationContainer
  }, /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: backgroundStyle === 'dark' ? '#BDBDBD' : 'rgba(73, 80, 87, 1)'
    }
  }, renderLocationLabel())), /*#__PURE__*/_react.default.createElement(_core.Button, {
    "aria-expanded": open ? 'true' : undefined,
    onClick: handleClick,
    classes: {
      root: buttonClass
    }
  }, /*#__PURE__*/_react.default.createElement(_icons.MoreVert, null)), /*#__PURE__*/_react.default.createElement(_core.Menu, {
    anchorEl: anchorEl,
    open: open,
    getContentAnchorEl: null,
    onClose: handleClose,
    className: classes.menu,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'left'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'left'
    }
  }, /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
    className: classes.mi,
    onClick: openStylePopover
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    style: {
      textTransform: 'none'
    },
    className: classes.btn,
    onClick: openStylePopover
  }, /*#__PURE__*/_react.default.createElement(_icons.FormatSize, {
    className: classes.icon
  }), "Estilo")), /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
    className: classes.mi,
    onClick: openReferencesPopover
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    style: {
      textTransform: 'none'
    },
    className: classes.btn,
    onClick: openReferencesPopover
  }, /*#__PURE__*/_react.default.createElement(_icons.FormatQuote, {
    className: classes.icon
  }), "Refer\xEAncia"))), /*#__PURE__*/_react.default.createElement(_StylesPopover.default, null), /*#__PURE__*/_react.default.createElement(_ReferencesPopover.default, null)));
}
var _default = exports.default = TopBarMobile;